export function isValidWebAppLocale(locale: string): boolean {
  const { $availableWebAppLocales } = useNuxtApp();

  return $availableWebAppLocales.value.includes(locale);
}
